var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 6.2V15.8C15.75 16.0485 15.5485 16.25 15.3 16.25H5.7C5.45147 16.25 5.25 16.0485 5.25 15.8V6.2C5.25 5.95147 5.45147 5.75 5.7 5.75H15.3C15.5485 5.75 15.75 5.95147 15.75 6.2Z",
    stroke: "#2A2E34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.5H3.45C3.20147 3.5 3 3.70147 3 3.95V14",
    stroke: "#2A2E34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68152 9.1588C9.3816 8.97888 9 9.19488 9 9.54468V12.4551C9 12.8049 9.3816 13.0209 9.68152 12.841L12.1069 11.3858C12.3982 11.211 12.3982 10.7888 12.1069 10.614L9.68152 9.1588Z",
    stroke: "#2A2E34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.667220bf82440e3ea899d2589c9da0c0.svg";
export { ForwardRef as ReactComponent };